import { Component, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { signQr } from '../state/form.actions';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  templateUrl: './sign.component.html',
  imports: [FormsModule, ReactiveFormsModule, TranslatePipe],
})
export class SignComponent {
  activeModal = inject(NgbActiveModal);
  private readonly store = inject(Store);

  name = new FormControl('');

  async submit() {
    if (this.name.value) {
      this.activeModal.close();
      this.store.dispatch(
        signQr({
          signature: this.name.value,
        }),
      );
    }
  }
}
